var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVimeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.969 8.552c-0.141 3.12-2.319 7.396-6.527 12.812-4.355 5.667-8.031 8.496-11.052 8.496-1.88 0-3.437-1.724-4.74-5.172l-2.557-9.491c-0.957-3.443-1.979-5.167-3.077-5.167-0.24 0-1.079 0.5-2.511 1.505l-1.505-1.943c1.579-1.391 3.136-2.776 4.667-4.167 2.104-1.828 3.688-2.781 4.74-2.88 2.489-0.24 4.020 1.469 4.599 5.115 0.62 3.937 1.047 6.385 1.292 7.344 0.719 3.265 1.509 4.901 2.369 4.901 0.667 0 1.672-1.063 3.021-3.183 1.339-2.12 2.052-3.729 2.145-4.839 0.193-1.823-0.527-2.745-2.151-2.745-0.765 0-1.557 0.163-2.371 0.521 1.584-5.156 4.579-7.677 9.016-7.516 3.297 0.079 4.839 2.219 4.656 6.396z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.b339d977733cb824495ca39b4ab7a85b.svg";
export { ForwardRef as ReactComponent };